import { render, staticRenderFns } from "./EventEmptySearchLayout.vue?vue&type=template&id=61ee6d57"
import script from "./EventEmptySearchLayout.vue?vue&type=script&lang=js"
export * from "./EventEmptySearchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports